var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "youtube_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.354 6.238c.492.133.878.52 1.009 1.011C15.6 8.14 15.6 10 15.6 10s0 1.86-.237 2.75c-.133.494-.52.88-1.009 1.012C13.466 14 9.9 14 9.9 14s-3.564 0-4.454-.238a1.43 1.43 0 0 1-1.008-1.011C4.2 11.86 4.2 10 4.2 10s0-1.86.238-2.75c.132-.494.518-.88 1.008-1.012C6.336 6 9.9 6 9.9 6s3.566 0 4.454.238M11.723 10 8.76 11.715v-3.43z",
  clipRule: "evenodd"
})));
export default SvgYoutube;